
module.exports = {
    // "paymentErrors": {
    //     "copays": [
    //         {
    //             "itemId": 123123,
    //             "copayCredits": [
    //                 {
    //                     "dateCreated": {
    //                         "date": "2020-04-22 14:18:02.000000",
    //                         "timezone_type": 3,
    //                         "timezone": "America/Chicago"
    //                     },
    //                     "itemId": "10075715",
    //                     "itemName": "Just Sold 1 Agent Large (01)",
    //                     "creditUsed": 39
    //                 },
    //                 {
    //                     "dateCreated": {
    //                         "date": "2022-02-09 07:28:49.000000",
    //                         "timezone_type": 3,
    //                         "timezone": "America/Chicago"
    //                     },
    //                     "itemId": "12326197",
    //                     "itemName": "Just Sold 1 Agent Small No Price(02)",
    //                     "creditUsed": 36.88
    //                 }
    //             ]
    //         },
    //         {
    //             "itemId": 12326239,
    //             "copayCredits": [
    //                 {
    //                     "dateCreated": {
    //                         "date": "2022-02-09 07:29:14.000000",
    //                         "timezone_type": 3,
    //                         "timezone": "America/Chicago"
    //                     },
    //                     "itemId": "12326198(Pending)",
    //                     "itemName": "Just Sold 1 Agent Small No Price(02)",
    //                     "creditUsed": 36.88
    //                 }
    //             ]
    //         },
    //         {
    //             "itemId": 12326239,
    //             "copayCredits": [
    //                 {
    //                     "dateCreated": {
    //                         "date": "2020-04-22 14:18:02.000000",
    //                         "timezone_type": 3,
    //                         "timezone": "America/Chicago"
    //                     },
    //                     "itemId": "10075715",
    //                     "itemName": "Just Sold 1 Agent Large (01)",
    //                     "creditUsed": 39
    //                 },
    //                 {
    //                     "dateCreated": {
    //                         "date": "2022-02-09 07:28:49.000000",
    //                         "timezone_type": 3,
    //                         "timezone": "America/Chicago"
    //                     },
    //                     "itemId": "12326197",
    //                     "itemName": "Just Sold 1 Agent Small No Price(02)",
    //                     "creditUsed": 36.88
    //                 }
    //             ]
    //         }
    //     ]
    // },


    "result": 0,
    "date_created": {"date": "2021-10-19 21:58:04.000000", "timezone_type": 3, "timezone": "America\/Chicago"},
    "date_modified": {"date": "2021-10-19 21:58:47.000000", "timezone_type": 3, "timezone": "America\/Chicago"},
    "cartId": 6905810,
    "cartType": "APM2",
    // "status": "pending",
    // "status": "processing",
    "items": [
        // require("./sample-item-pickpack"),
        sampleItem({itemId: "123123"}),
        sampleItem({
            itemId: "123124",
            // approvalInfo: {
            //     approvalRequired: true,
            // },
        }),
    ],
    "allowShippingConsolidation": false,
    // shipping: {
    //     breakShippingConsolidation: true,
    // },
    "appliedCredits": {
        // storeCredits: [
        //     {
        //         amount: 1,
        //         itemId: "123123",
        //     },
        // ],
        adBudgets: [
            {
                amount: 1,
                itemId: "123123",
        //      billingAdjustment: 11,
                comments: "test comment",
            },
        ],
        // vouchers: [
        //     {
        //         amount: 1,
        //         itemId: "123123",
        //         name: "Test",
        //     },
        // ],
        // "copays": [
        //     {
        //         itemId: "123123",
        //         "amount": 77.7,
        //         copayAddress: {
        //             mls: "94569",
        //             streetAddress: "123 ABC DEF",
        //             zip: "45348",
        //         }
        //     },
        //     // {
        //     //     itemId: "2222",
        //     //     "amount": 77.7,
        //     // },
        // ],
    },
    "appliedPayments": {
        creditCards: [
            {
                "zip": "76137",
                "country": "USA",
                "isExpiredCard": false,
                "city": "ftworth",
                "cardHolderName": "Test card",
                // "isDefaultCard": true,
                type: "nonce",
                nonce: "423423",
                // "cardType": "Visa",
                "cardType": "Discover",
                // "cardToken": "kn7nczg",
                "cardBin": "411111",
                "streetAddress": "4901NBeach",
                "cardExpirationMonth": "12",
                "cardExpirationYear": "2020",
                "expiration": "12\/2020",
                "state": "TX",
                "cardNumber": "411111 xxxxxx 1111",
                "cardLast4": "1111"
            },
            // {cardToken: "kn7nczg", amount: 3},
            // {cardToken: "7zh27f"},
        ],
        "billing": [
            // {
            //     "name": "ACME Billing",
            //     "billingId": "billing-1",
            //     "amount": 5,
            //     "itemId": "123123",
            //     "meta1": "1.9.01 - CSBU",
            //     "meta2": 2,
            //     "comments": "Testing"
            // },
            // {
            //     "name": "ACME Billing",
            //     "billingId": "billing-1",
            //     "amount": 5,
            //     "itemId": "123124",
            //     "meta1": "1.9.01 - CSBU",
            //     "meta2": 1,
            //     "comments": "Testing"
            // },
        ]
    },
};

function sampleItem({itemId, approvalInfo}) {
    return {

        itemId,
        // "itemId": "123123",
        "sku": {"front": "402193", "back": "402193"},
        "copays": {"mls": "12121212123", "streetAddress": "957 pintail ct", "zip": "75019"},
        "programType": "APM2",
        "programData": {"id": "7b61c906", "eventName": "Price Change", "eventTypeId": "priceChange"},
        "itemName": "Price Change - 957 pintail ct - Postcard",
        "orderDate":{"date":"2023-01-10 04:04:27.000000","timezone_type":3,"timezone":"America\/Chicago"},
        "metaData": {
            "ccReference": "e3944e19-4e1c-499f-b279-d733dc8b6365",
            "eventId": "327da190-2858-11ec-ae5b-d3830cafa76f",
            "ccReferenceURLs": {
                "pdf": ["https:\/\/ds-dev.xpressdocs.com\/api\/rendering\/GetHiResOutput\/781792f7-10e0-4701-9373-c84e8fdf87b2\/e3944e19-4e1c-499f-b279-d733dc8b6365\/0_0.pdf?version=ab92357b-ce99-4c87-b5ce-a6adc9ef2f1c", "https:\/\/ds-dev.xpressdocs.com\/api\/rendering\/GetHiResOutput\/781792f7-10e0-4701-9373-c84e8fdf87b2\/e3944e19-4e1c-499f-b279-d733dc8b6365\/1_0.pdf?version=ab92357b-ce99-4c87-b5ce-a6adc9ef2f1c"],
                "jpg": ["http:\/\/imgproxy.xpressdocs.com\/image\/jpeg\/2000x2000\/https:\/\/ds-dev.xpressdocs.com\/api\/rendering\/GetHiResOutput\/781792f7-10e0-4701-9373-c84e8fdf87b2\/e3944e19-4e1c-499f-b279-d733dc8b6365\/0_0.pdf?version=2c8e3ab2-4489-4754-9b8a-ac71c79ef42d", "http:\/\/imgproxy.xpressdocs.com\/image\/jpeg\/2000x2000\/https:\/\/ds-dev.xpressdocs.com\/api\/rendering\/GetHiResOutput\/781792f7-10e0-4701-9373-c84e8fdf87b2\/e3944e19-4e1c-499f-b279-d733dc8b6365\/1_0.pdf?version=2c8e3ab2-4489-4754-9b8a-ac71c79ef42d"]
            },
            "inputData": {
                "styles": {"Back": {"Headshots": "0 headshots"}},
                "text": {
                    "Front": {
                        "field03": "Price Change",
                        "field02": "957 pintail ct, coppell, TX 75019\n$430000\n1 Beds, 1 Baths,  SQ.FT."
                    },
                    "Back": {
                        "field11": "Price:",
                        "field09": "Acme Demo Office\n1301 NE Loop 820\nFort Worth, TX 76131\nPH: 866.977.3627\nOFF: 214-334-7745\nxpressdocs.com",
                        "field07": "Each office is independently owned and operated.",
                        "field06": "$430,000",
                        "field05": "Opportunity for instant equity! This motivated home owner has reduced their asking price...",
                        "field04": "Price Change\n957 pintail ct, coppell, TX 75019",
                        "field03": "Licensed RE Salesperon\njagent@acme.com\nm. 866.977.3627\njohnagent.com\n",
                        "field02": "John Agent"
                    }
                }
            },
            "productName": "5.5 x 8.5 Large Postcard"
        },
        "itemThumbnails": [
            // "https://i.picsum.photos/id/270/300/200.jpg?hmac=HY_IeaSEL1tIy0SoQHksjsYZ3RUm3QgpglRtgplphnw",
            "https:\/\/assets.awsdev.xpressdocs.com\/dserv\/tpl\/250\/1\/402193.jpg"
        ],

        proofUrls: {
            jpg: [
                {path: "https://assets.awsdev.xpressdocs.com/dserv/tpl/small/2/393931.jpg"},
                {path: "https://assets.awsdev.xpressdocs.com/dserv/tpl/small/2/393931.jpg"},
                {path: "https://assets.awsdev.xpressdocs.com/dserv/tpl/small/2/393931.jpg"},
            ],
            pdf: [{path: "https://assets.awsdev.xpressdocs.com/dserv/tpl/small/2/393931.jpg"}],
            zip: [{path: "https://assets.awsdev.xpressdocs.com/dserv/tpl/small/2/393931.jpg"}],
        },

        "selections": {
            "distributionType": "shipping",
            // "distributionType": "download",
            // "distributionType": "pickup",
            // "distributionType": "mailing",
            "distributionLevel": "3",

            futureFulfillment: 1,
            scheduledDate: "2022-01-11",
            idIndicia: 1,

            "options": [
                {
                    "name": "PDF Download",
                    "dev_key": "pdf_download",
                    "value": true,
                    "flatPrice": "2.50"
                }, {
                    "group": "PaperTypes",
                    "dev_key": "paper_type",
                    "id": 4,
                    "name": "Premium Cover Stock",
                    "desc": "Premium Cover Stock",
                    "default": true
                }, {
                    "id": "1",
                    "name": "Side 1",
                    "desc": "High Gloss Coating Front",
                    "group": "Finishing",
                    "subGroup": "Gloss Coating",
                    "dev_key": "high_gloss_coating",
                    "unitPrice": "0.00",
                    "finishingDelay": 0,
                    "coatingDescription": "Glossy appearance enhances color contrast to make photos and vibrant colors pop."
                },
                {
                    "group": "lineItem",
                    "name": "Envelopes",
                    "dev_key": "envelopes",
                    "description": "Flat paper container with a sealable flap used to enclose a letter or document",
                    "type": "boolean",
                    "isUi": true,
                    "isRequired": true,
                    "flatPrice": "0.120000",
                },
                {
                    "desc": "Okay to Mail early",
                    "dev_key": "okay_to_mail_early",
                    id: 34,
                    name: "true",
                },
            ],
            // "mailingListIds": [
            //     {
            //         "id": "7503491",
            //         "name": "957 pintail ct",
            //         "quantity": 50,
            //         "type": "radius",
            //         "typeId": 2,
            //         "requirePurchase": true,
            //         "unitPrice": 0,
            //         "actualUnitPrice": "0.0150000",
            //         hasSubscriptionBenefit: true,
            //     },
            //     // {
            //     //     "id": "546",
            //     //     "name": "123 ABC ct",
            //     //     "quantity": 50,
            //     //     "type": "radius",
            //     //     "typeId": 2,
            //     //     "requirePurchase": true,
            //     //     "unitPrice": "0.050000"
            //     // },
            // ],
            "quantity": 50,
            "unitPrice": 0,
            "is3rdParty": false,
            "supplier": ""
        },
        "billingAvailable": {
            "voucher": [{
                "name": "APM2 voucher",
                "id": "1dd6e30c34",
                "amountAvailable": "11.75",
                "desc": "Corporate Voucher"
            }],
            "billingAccount": [
                {
                    "name": "ACME Billing",
                    "id": "billing-1",
                    "amountAvailable": "100%",
                    "desc": "Please select this option to bill this order to the ACME Billing Account. ",
                    "fieldsTitle": "Enter your cost center number here for validation",
                    "fields": {
                        "billingAdjustment": {"type": "Number", "label": "Calculate Billing", "required": false},
                        "comments": {"type": "string", "label": "Billing Comments", "required": false},

                        "meta1": {
                            "type": "array",
                            "label": "Org ID - Name (required)",
                            "required": true,
                            "meta1Dropdown": "1.9 - Smartronix,1.9.01 - CSBU,1.9.02 - ISRBU,1.9.03 - EITBU,1.9.04 - HR,1.9.05 - Business intelligence,1.9.06 - Safety & security,1.9.07 - Talent acquisition,1.9.08 - FA/Program Control,1.9.09 - Executive Leadership,1.9.10 - Facilities,1.9.11 - Purchasing,1.9.12 - Subcontracting,1.9.13 - Accounting,1.9.14 - Business Development,1.9.15 - Bid & Proposal,1.9.16 - Contracts,1.9.17 - Legal,1.9.18 - IT,1.9.19 - Strategy & Technology,1.9.20 - Selling & Marketing,1.9.21 - Import/Export,1.9.22 - Quality,1.9.23 - Logistics,1.9.24 - Training,1.9.25 - Communications,1.9.99 - Interco Eliminations,1.9.SM - SMX Other NOTREG Bus Area"
                        },
                        meta2: {"type": "Number", "label": "Meta", "required": false, sumMetaFieldsOnApply: true},
                    }
                },
                {
                    "name": "ACME Billing 2",
                    "id": "billing-2",
                    "amountAvailable": "100%",
                    "desc": "Please select this option to bill this order to the ACME Billing Account. ",
                    "fieldsTitle": "Enter your cost center number here for validation",
                    // "fields": {
                    //     "billingAdjustment": {"type": "Number", "label": "Calculate Billing", "required": false},
                    //     "comments": {"type": "string", "label": "Billing Comments", "required": false},
                    //
                    //     "meta1": {
                    //         "type": "array",
                    //         "label": "Org ID - Name (required)",
                    //         "required": true,
                    //         "meta1Dropdown": "1.9 - Smartronix,1.9.01 - CSBU,1.9.02 - ISRBU,1.9.03 - EITBU,1.9.04 - HR,1.9.05 - Business intelligence,1.9.06 - Safety & security,1.9.07 - Talent acquisition,1.9.08 - FA/Program Control,1.9.09 - Executive Leadership,1.9.10 - Facilities,1.9.11 - Purchasing,1.9.12 - Subcontracting,1.9.13 - Accounting,1.9.14 - Business Development,1.9.15 - Bid & Proposal,1.9.16 - Contracts,1.9.17 - Legal,1.9.18 - IT,1.9.19 - Strategy & Technology,1.9.20 - Selling & Marketing,1.9.21 - Import/Export,1.9.22 - Quality,1.9.23 - Logistics,1.9.24 - Training,1.9.25 - Communications,1.9.99 - Interco Eliminations,1.9.SM - SMX Other NOTREG Bus Area"
                    //     },
                    //     meta2: {"type": "Number", "label": "Meta", "required": false, sumMetaFieldsOnApply: true},
                    // }
                },
            ],
            "copay": {
                "bypassOption": false,
                "propertyIdType": "mls",
                "description": "Test APM2 Copay",
                "checkMls": true,
                "checkAddress": true,
                "fields": {
                    "mls": {"label": "Property MLS Number", "type": "string"},
                    "streetAddress": {"type": "string", "label": "Property Address"},
                    "copayAdjustment": {"type": "string", "label": "Adjust Copay To"},
                    "mlsBypass": {"type": "string", "label": "MLS By pass"},
                    "zip": {"type": "string", "label": "Property Zip"},
                },
                "amountAvailable": 24
            },
            "promoCode": true,

            "adbudget":[
                {
                    "name":"BHHS FL Network Quarterly PC 50 Large ",
                    "id":"ddf91a94",
                    "amountAvailable":36.02000000000000312638803734444081783294677734375,
                    "desc":"50 large postcards once per quarter for Quarterly Postcard Program. Standard Mail only",
                    "fields":{
                        "meta1": {
                            "type": "array",
                            "label": "Org ID - Name (required)",
                            "required": true,
                            "meta1Dropdown": "1.9 - Smartronix,1.9.01 - CSBU,1.9.02 - ISRBU,1.9.03 - EITBU,1.9.04 - HR,1.9.05 - Business intelligence,1.9.06 - Safety & security,1.9.07 - Talent acquisition,1.9.08 - FA/Program Control,1.9.09 - Executive Leadership,1.9.10 - Facilities,1.9.11 - Purchasing,1.9.12 - Subcontracting,1.9.13 - Accounting,1.9.14 - Business Development,1.9.15 - Bid & Proposal,1.9.16 - Contracts,1.9.17 - Legal,1.9.18 - IT,1.9.19 - Strategy & Technology,1.9.20 - Selling & Marketing,1.9.21 - Import/Export,1.9.22 - Quality,1.9.23 - Logistics,1.9.24 - Training,1.9.25 - Communications,1.9.99 - Interco Eliminations,1.9.SM - SMX Other NOTREG Bus Area"
                        },
                        "comments":{
                            "type":"string",
                            "label":"Billing Comments",
                            "required":true
                        },
                        "billingAdjustment":{
                            "type":"Number",
                            "label":"Calculate Billing",
                            "required":false
                        }
                    }
                }
            ],
            storecredit: [
                {
                    id: "234234",
                    amountAvailable: 2,
                },
            ],
        },
        "approvalInfo": {
            "approvalRequired": false,
            "enableApprovalButton": false,

            // "approvalType":"oci",
            "approvalType":"procurement",
            // "hookUrl":"",
            "hookUrl":"https:\/\/tecraaalam-web.awsdev.xpressdocs.com\/next\/xadmin\/test_tools\/punchout_order_post_process.php?sso_type=oci",

            ...approvalInfo,


            // "approvalRequired":true,
            // "enableApprovalButton":0,
            // "allowUserPayException":false,
            // "idOrderApproval":2055,
            // "approvalType":"xd_approval",
            // "error":"You have exceeded the allowable order amount 50 for this product. You can reduce your order to 50 or wait until 2023-09-26 to order more.",
            // "billingTotalExceeded":true,
            // "approvalName":"Submit for Approval",
            // "location":"order_summary",

        },
        "itemTotals": [
            {"name": "Subtotal", "type": "subTotal", "amount": 5},
            {"name": "Promo Code", "type": "promoCode", "amount": 3},
            {
                "name": "Sales Tax",
                "type": "salesTax",
                "amount": 0
            }
        ],
        "shipping": {
            "addressId": 665254,
            "serviceLevel": "GROUND_HOME_DELIVERY",
            // breakShippingConsolidation: true,
            "shippingAddress": {
                "idPrimary": 946735,
                "dateCreated": {
                    "date": "2021-05-25 11:05:59.000000",
                    "timezone_type": 3,
                    "timezone": "America\/Chicago"
                },
                "dateModified": {
                    "date": "2021-05-25 11:06:00.000000",
                    "timezone_type": 3,
                    "timezone": "America\/Chicago"
                },
                "idEntity": "32517238",
                "isInternational": false,
                "type": "residential",
                "isVisible": true,
                "contactName": "TEST",
                "company": "TEST",
                "address1": "1301 NE LOOP 820",
                "address2": "",
                "city": "FORT WORTH",
                "state": "TX",
                "postalCode": "76131",
                "plus4": null,
                "deliveryPoint": null,
                "checkDigit": null,
                "countryCode": "US",
                "contactPhone": "123-456-7890",
                "cassStatus": true,
                "failed": false,
                "errorCode": "",
                "defaultBranch": true
            },
            // "shippingCharge": "7.000000",
            "shippingCharge": 0,
            "breakConsolidationCharge": 0,
            "estimatedDeliveryDate": "2021-12-01 23:59:00",
            "estimatedDeliveryMessage": "Between Wed, Dec 01, 2021 and Fri, Dec 03, 2021 by 11:59pm Local Time",
            "breakShippingConsolidation": true
        },
        "sampleShippingAddressId": 284706,
        "mailingClass": "3",
        "distributionMethod": "third class",
        "source": null
    };
}
